/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76702ResListItem {
  
  /** 模版Id */
  templateId?: string;
  
  /** 模板名 */
  templateName?: string;
  
};
    
  



export interface API76702Req {
  
  /** 关键词 */
  keyword?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API76702Res {
  /** T  */
  list?: IAPI76702ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76702 查询模版信息

export interface IUseGetAPI76702Return {
  /** 查询模版信息: 接口请求状态 */
  isAPI76702Loading: boolean;
  /** 查询模版信息: 接口请求返回数据 */
  dataAPI76702: API76702Res;
  /**  查询模版信息: 接口数据请求方法 */
  fetchAPI76702Data: (inputs: API76702Req, config?: YWRequestConfig) => Promise<API76702Res>;
  /** 查询模版信息: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76702 = ():IUseGetAPI76702Return => {
  let isMount = true;
  const [isAPI76702Loading, setIsAPI76702Loading] = useState(false);
  const [dataAPI76702, setDataAPI76702] = useState<API76702Res>({} as API76702Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/template/page`;

  const fetchAPI76702Data = async (inputs: API76702Req, config?: YWRequestConfig): Promise<API76702Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76702Req>) || {}) as API76702Req;
    
  
    if ( isMount ) {
      setIsAPI76702Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76702Res>(`${basePath}/yoaichat-web/task/instance/template/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76702(res || {} as API76702Res);
        setIsAPI76702Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76702Loading(false);
      }
      return false as unknown as API76702Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76702Loading,
    dataAPI76702,
    fetchAPI76702Data,
    requestUrl,
  }
}

